import React from "react";
import PlayerItemSmall from "../player/small";
import { formatName } from "../../../libs/formatName";
import { Player } from "../../../types";
import Avatar from "../../avatar";

const ReservationItemCompact = ({
	date,
	club,
	court,
	sport,
	partners,
	className = "",
}: {
	date: any;
	club: string;
	court: string;
	sport: string;
	partners: any;
	className?: string;
}) => (
	<div className={`item reservation compact ${className}`} data-number-of-partners={partners.length}>
		<div className="itemBody">
			<div className="badge primary">
				{date.format("ddd, MMM D")}
				&nbsp;at&nbsp;
				{date.format("HH:mm")}
			</div>
			<div className="title">
				{club}
			</div>
			<div className="meta">
				{court}
			</div>
		</div>
		<div className="itemImage">
			<div className="partners">
				{partners.map((player: Player, index: number) => (
					<Avatar photoUrl={player.photoUrl} key={index} />
				))}
			</div>
		</div>
	</div>
);

export default ReservationItemCompact;
